import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';

import { MainComponent } from './main/main.component';
import { OrderComponent } from './order/order.component';
import { ListComponent } from './list/list.component';
import { PartnerComponent } from './partner/partner.component';
import { RegComponent } from './partner/reg/reg.component';
import { PaymentComponent } from './payment/payment.component';
import { AccountComponent } from './account/account.component';
import { UserComponent } from './account/user/user.component';
import { AdminComponent } from './admin/admin.component';
import { MemberComponent } from './admin/member/member.component';
import { BasicComponent } from './admin/basic/basic.component';
import { ConfigComponent } from './admin/config/config.component';
import { AppsComponent } from './admin/apps/apps.component';
import { AgreeComponent } from './admin/apps/agree/agree.component';
import { PrivacyComponent } from './admin/apps/privacy/privacy.component';
import { GpsComponent } from './admin/apps/gps/gps.component';
import { RequestComponent } from './admin/request/request.component';
import { SmsComponent } from './admin/sms/sms.component';
import { SmshistoryComponent } from './admin/sms/smshistory/smshistory.component';
import { SmspayComponent } from './admin/sms/smspay/smspay.component';
import { SmsorderComponent } from './admin/sms/smsorder/smsorder.component';
import { RviewComponent } from './admin/request/rview/rview.component';
import { InquiryComponent } from './admin/inquiry/inquiry.component';
import { NotAuthorizedComponent } from './not-authorized/not-authorized.component';

import { Error404Component } from './error404/error404.component';

const routes: Routes = [
  { path: 'main', component: MainComponent },
  { path: '', redirectTo: 'main', pathMatch: 'full' },
  { path: 'order', component: OrderComponent },
  { path: 'list', component: ListComponent },
  { path: 'partner', component: PartnerComponent },
  { path: 'partner/reg', component: RegComponent },
  { path: 'payment', component: PaymentComponent },
  { path: 'account', component: AccountComponent },
  { path: 'account/user', component: UserComponent },
  { path: 'admin', component: AdminComponent },
  { path: 'admin/request', component: RequestComponent },
  { path: 'admin/request/rview', component: RviewComponent },
  { path: 'admin/member', component: MemberComponent },
  { path: 'admin/basic', component: BasicComponent },
  { path: 'admin/config', component: ConfigComponent },
  { path: 'admin/apps', component: AppsComponent },
  { path: 'admin/apps/agree', component: AgreeComponent },
  { path: 'admin/apps/privacy', component: PrivacyComponent },
  { path: 'admin/apps/gps', component: GpsComponent },
  { path: 'admin/sms', component: SmsComponent },
  { path: 'admin/sms/smshistory', component: SmshistoryComponent },
  { path: 'admin/sms/smspay', component: SmspayComponent },
  { path: 'admin/sms/smsorder', component: SmsorderComponent },
  { path: 'admin/inquiry', component: InquiryComponent },
  { path: 'not-use', component: NotAuthorizedComponent },
  { path: '**', pathMatch: 'full', component: Error404Component },
];

@NgModule({
	declarations: [],
	imports: [
		RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, useHash: false, onSameUrlNavigation: 'reload' }),
		CommonModule
	],
	exports: [RouterModule]
})
export class AppRoutingModule { }
